// Rejection-email config for AI-scoring auto-reject (ENG-3114). Kept in its own
// ES module (not the AiScoreInterface namespace) so the section component file
// only exports a component (react-refresh) and to avoid the namespace lint rule.

// Persisted shape mirroring the backend `ai_scoring_attributes` email fields.
// schedule/cc/bcc live in the backend `options` JSON; surfaced here flat.
export interface AutoRejectEmailConfig {
  sendEmail: boolean;
  atsCommTemplateId: number | null;
  senderId: number | null;
  atsSharedEmailId: number | null;
  schedule: boolean;
  sendAfter: number | null;
  scheduledAt: string | null;
  scheduledAtTimezone: string | null;
  cc: string[];
  bcc: string[];
}

// Formik values for the auto-reject rejection-email "island" form. Mirrors the
// fraud-detector form so the shared email components (useEmailField,
// ScheduleRejectionEmail) can be reused as-is.
export interface AutoRejectEmailFormValues {
  sendRejectEmail: boolean;
  selectedTemplate: Record<string, unknown> | null;
  from: string;
  fromUserObject: Record<string, unknown> | null;
  subject: string;
  body: string;
  cc: string[];
  bcc: string[];
  attachments: unknown[];
  scheduleEmail: boolean;
  sendAfter: number;
  scheduleTime: string | null;
  scheduleTimezone: unknown;
}

export const AUTO_REJECT_EMAIL_DEFAULTS: AutoRejectEmailFormValues = {
  sendRejectEmail: false,
  selectedTemplate: null,
  from: '',
  fromUserObject: null,
  subject: '',
  body: '',
  cc: [],
  bcc: [],
  attachments: [],
  scheduleEmail: false,
  sendAfter: 1,
  scheduleTime: null,
  scheduleTimezone: null,
};
